<!-- タイプに基づくおすすめ 表示アイテム -->
<template>
  <div class="recommend-mode-component">
    <div v-if="!recommendMode.isSupported" class="recommend-mode-overlay"></div>
    <div
      v-if="!recommendMode.isSupported"
      class="recommend-mode-overlay-textbox"
    >
      <div class="recommend-mode-overlay-text">
        {{ $t("recommend.mode.notSupported") }}
      </div>
    </div>
    <div class="recommend-mode-machine-image-wrapper">
      <img v-if="machineImageData" :src="machineImageData" alt="machineImage" />
      <div v-else class="loading-icon"></div>
    </div>
    <div class="recommend-mode-container-text-wrapper">
      <div class="recommend-mode-text-container">
        <div ref="recommendModeName" class="recommend-mode-name">
          {{ recommendMode.careModeName }}
        </div>
        <div class="recommend-mode-detail">
          {{ recommendMode.detail }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetchAPI from "@/utils/fetch";
import consoleController from "@/utils/logUtil";
import store from "@/utils/store";

export default {
  props: {
    /**
     * 以下をキーに持つオブジェクト
     * machineImageId: 機器の画像を一意に特定するId
     * careModeName: おすすめモード名
     * color: おすすめモードの色
     * detail: おすすめしているモードの説明
     * isSupported: おすすめしているモードに対応しているか(bool)
     */
    recommendMode: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      machineImageData: null,
    };
  },
  computed: {},
  mounted() {
    this.getMasterImage(this.recommendMode.machineImageId);
    this.$nextTick(() => {
      const { recommendModeName } = this.$refs;
      recommendModeName.style.backgroundColor = `#${this.recommendMode.color}`;
    });
  },
  methods: {
    async getMasterImage(imageId) {
      const { fetch } = fetchAPI;
      const path = "/web/master/image";
      const queryParams = {
        imageId,
      };
      const lang = store.getUrlLang();
      if (lang !== "") {
        queryParams.lang = lang;
      }
      try {
        const res = await fetch.fetchAPI("GET", path, queryParams);
        if (res !== undefined && res.status === 200) {
          const responseData = await res.json();
          this.machineImageData = `data:image/jpeg;base64, ${responseData.imageBase64}`;
        } else if (res !== undefined && res.status !== 200) {
          // 画像の取得失敗ではエラーダイアログを表示しない
          const errorInfo = await res.json();
          consoleController(
            "error",
            `failed to get master image. errorInfo: ${JSON.stringify(
              errorInfo,
              null,
              4
            )}`
          );
        } else {
          consoleController("error", `failed to get master image.`);
        }
      } catch (e) {
        consoleController("error", `${path}?imageId=${imageId} is failed.`);
      }
    },
  },
};
</script>

<style scoped>
.recommend-mode-component {
  height: 80px;
  width: auto;
  margin-left: 26px;
  margin-right: 26px;
  margin-top: 12px;
  margin-bottom: 12px;
  position: relative;

  opacity: 1;
}

.recommend-mode-machine-image-wrapper {
  height: 72px;
  width: 72px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
}
.recommend-mode-machine-image-wrapper img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.loading-icon {
  /* TODO: 画像ローディング中の表示について確認 */
  margin: auto;
}

.recommend-mode-container-text-wrapper {
  position: absolute;
  top: 50%;
  left: 56px;
  transform: translate(0, -50%);
  text-align: left;
  height: 100%;
  width: calc(100% - 40px);
}

.recommend-mode-text-container {
  position: relative;
  height: 100%;
  width: 100%;
}

.recommend-mode-name {
  position: absolute;
  top: 10px;
  left: 12px;
  width: 158px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font: normal normal normal 14px/19px Roboto;
  letter-spacing: 0px;
  color: #fff;
  opacity: 1;
}
.recommend-mode-detail {
  font: normal normal normal 13px/19px Noto Sans JP;
  position: absolute;
  top: 38px;
  left: 12px;
  height: 38px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  white-space: pre-line;
}

.recommend-mode-overlay {
  height: 100px;
  width: calc(100% + 20px);
  position: absolute;
  top: -10px;
  left: -10px;
  display: grid;
  justify-items: center;
  align-content: center;

  background: #000000 0% 0% no-repeat padding-box;
  opacity: 0.3;
  border-radius: 8px;
  z-index: 1;
}

.recommend-mode-overlay-textbox {
  height: 28px;
  width: auto;
  padding: 0px 13px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  justify-items: center;
  align-content: center;
  margin: 0 auto;

  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 60px;
  opacity: 1;
  z-index: 2;
}

.recommend-mode-overlay-text {
  height: 20px;
  width: auto;
  display: grid;
  justify-items: center;
  align-content: center;
  margin: 4px auto;
  white-space: nowrap;

  text-align: center;
  font: normal normal normal 14px/22px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.9;
}
</style>
